import API from "../API";
import { getGuestTokenParams, withGuestTokenPayload } from "../../token/token";

export const getDeliveryAddressesApi = async () => {
  try {
    const response = await API.get(`/ecommerce/delivery-address`, {
      params: getGuestTokenParams(),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleDeliveryAddressApi = async (deliveryAddressId) => {
  try {
    const response = await API.get(
      `/ecommerce/delivery-address/${deliveryAddressId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postSingleDeliveryAddressApi = async (payload) => {
  try {
    const response = await API.post(
      `/ecommerce/delivery-address`,
      withGuestTokenPayload(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSingleDeliveryAddressApi = async (payload) => {
  try {
    const response = await API.put(
      `/ecommerce/delivery-address`,
      withGuestTokenPayload(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSingleDeliveryAddressApi = async (deliveryAddressId) => {
  try {
    const response = await API.delete(
      `/ecommerce/delivery-address?deliveryAddressId=${deliveryAddressId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const setDefaultDeliveryAddressApi = async (deliveryAddressId) => {
  try {
    const response = await API.put(
      `/ecommerce/delivery-address/${deliveryAddressId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
